<template>
  <div>        
    <div class="landing-wrapper" v-scroll="onScroll">
      <AppLayoutHeader class="header-logo--static" />

      <v-container
        class="px-sm-8 py-0 pa-md-0 fill-height landing-message">
        <v-row no-gutters justify="center">
          <div              
            data-aos="fade-right"
            data-aos-ease ="ease"
            data-aos-duration="1000"
            data-aos-delay="100">
            <h1 class="text-hero text-center text--fes-blue mb-0 mr-4">References and</h1>
          </div>

          <div              
            data-aos="fade-left"
            data-aos-ease ="ease"
            data-aos-duration="1000"
            data-aos-delay="100">
            <h1 class="text-hero text-center text--fes-magenta">further reading</h1>
          </div>            
        </v-row>           
      </v-container>

      <AppLayoutLinks :class="classes" />
    </div>

    <slot />

  </div>
</template>

<script>
import AppLayoutLinks from '@/layouts/AppLayoutLinks'
import AppLayoutHeader from '@/layouts/AppLayoutHeader'

export default {
  name: "AppLayoutSolutions",
  components: {
    AppLayoutLinks, 
    AppLayoutHeader
  },
  data() {
    return {
      classes: 'header-navlinks header-navlinks--absolute'
    }
  },
  methods: {
    onScroll (e) {
      const landingHeight = document.querySelector('.landing-wrapper').offsetHeight;
            
      if (e.currentTarget.scrollY >= landingHeight) {
        document.querySelector('.scroll-to-top').style.display = 'block';        
      } else {
        document.querySelector('.scroll-to-top').style.display = 'none';  
      }
    },    
  }
}
</script>

<style lang="scss" scoped>
.landing-wrapper {
  height: 320px;
  background: url("~@/assets/solutions/solutions-landing-bg.png");
  background-size: cover;
  background-position: center;
  position: relative;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    background: rgba(250, 250, 250, 0.72);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);     
  }  
}
</style>
